import { SmoothLink } from "@/components/providers/NavigationProvider";

export default function Logo() {
  return (
    <SmoothLink
      href="/"
      className="text-2xl font-bold text-gray-900 font-serif transition-all duration-300 hover:text-[#1D9E75] cursor-pointer"
    >
      Vela
    </SmoothLink>
  );
}
